import type { RouteRecordRaw, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { ipbFormRoutes } from './ipb-forms/routes'
import { useMeStore } from '@/stores/me'

const requireAuth = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
) => {
    const meStore = useMeStore()

    meStore.restoreSession()

    if (meStore.isAuthenticated) {
        next()
    } else {
        next({ name: 'investors-login' })
    }
}

export const investorRoutes: RouteRecordRaw[] = [
    {
        name: 'investors-login',
        path: '/investors/login',
        component: () => import('./login.vue'),
    },
    {
        name: 'investors-dashboard',
        path: '/investors/dashboard',
        component: () => import('./dashboard.vue'),
        beforeEnter: requireAuth,
    },
    {
        name: 'investors-completeAccount',
        path: '/investors/complete-account',
        component: () => import('./complete-account.vue'),
    },
    ...ipbFormRoutes,
]
